import React, {useState, useEffect} from 'react';
import { useHistory } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { auth } from '../firebase';
import { Avatar, ChatEngine } from 'react-chat-engine';
import axios from 'axios';

const Chats = () =>{
    const histroy = useHistory();
    const { user } = useAuth();
    const [loading, setLoading] = useState(true);
    const handleLogout = async () =>{
        await auth.signOut();
        histroy.push('/');
        return;
    }
    const getFile = async (url) =>{
        const response = await fetch(url);
        const data = await response.blob();
        return new File([data], "userPhoto.jpg", {type:'image/jpeg'})
    }
    useEffect(() => {
        if(!user || user === null){
            histroy.push("/");
            return;
        }
        axios.get('https://api.chatengine.io/users/me/', {
            headers :{
                "project-id" : "d3650729-fda0-464a-8106-b106f6ea3e95",
                "user-name" : user.email,
                "user-secret": user.uid
            }
        })
        .then(() =>{
            setLoading(false);
        })
        .catch(() =>{
            let formdata = new FormData();
            formdata.append('email', user.email);
            formdata.append('username', user.email);
            formdata.append('secret', user.uid);
            getFile(user.photoURL)
            .then((avatar) =>{
                formdata.append('avatar', avatar, avatar.name);
                axios.post("https://api.chatengine.io/users/",
                formdata, {headers:{"private-key": "ee655a6f-c25f-4dd2-8d11-5274b5122523"}} 
                )
                .then(() => setLoading(false))
                .catch((error) => console.log(error))
            })
        })
    }, [user, histroy]);
    if(!user || loading) return "Loading....";
    return(
        <div className = "chats-page">
            <div className = "nav-bar">
                <div className = "logo-tab">
                    TChat
                </div>
                <div onClick={handleLogout} className = "logout-tab">
                    Logout
                </div>
            </div>
            <ChatEngine 
                height = "calc(100vh - 66px)"
                projectID = "d3650729-fda0-464a-8106-b106f6ea3e95"
                userName = { user.email }
                userSecret = { user.uid }
            />
        </div>
    );
}
export default Chats;